const DEFAULT_UNITS = ["B", "KB", "MB", "GB"];
export function formatFileSize(bytes, options) {
    if (!bytes || bytes <= 0)
        return "0 B";
    const units = options?.units ?? DEFAULT_UNITS;
    const maxUnitIndex = Math.min(units.length - 1, options?.maxUnitIndex ?? units.length - 1);
    const rawIndex = Math.floor(Math.log(bytes) / Math.log(1024));
    const index = Math.min(maxUnitIndex, Math.max(0, rawIndex));
    const value = bytes / Math.pow(1024, index);
    const precision = index === 0 ? 0 : 1;
    return `${value.toFixed(precision)} ${units[index]}`;
}
export const formatBytes = formatFileSize;
